import React from 'react';
import { func, bool, string, oneOfType } from 'prop-types';

import './FacetHeader.scss';

FacetHeader.propTypes = {
  toggleSearchView: func,
  useFacetSearch: bool,
  showResetAllButton: oneOfType([func, string, bool]),
  handleReset: func
};

export default function FacetHeader(props) {
  return (
    <React.Fragment>
      <a className="advanced-search__search-mode-switch" onClick={props.toggleSearchView}>
        {props.useFacetSearch ? 'Switch to Advanced Search' : 'Switch to Facet Search'}
      </a>
      {props.showResetAllButton && (
        <a className="advanced-search__facet-reset-button" onClick={props.handleReset}>
          <i className="icon-cw" />
          Reset
        </a>
      )}
    </React.Fragment>
  );
}
